import Firebase from "firebase";

const config = {
  apiKey: "AIzaSyBxRUUMvfnWF5xwNcneFs5w9HKy677Poj0",
  authDomain: "a5-convites.firebaseapp.com",
  databaseURL: "https://a5-convites.firebaseio.com",
  projectId: "a5-convites",
  storageBucket: "a5-convites.appspot.com",
  messagingSenderId: "288499503779"
};

const connection = !Firebase.apps.length ? Firebase.initializeApp(config) : "";
const DB = connection.database();
const AUTH = connection.auth();
const STORAGE = connection.storage();

export default function install(Vue, { router }) {
  // AUTH.onAuthStateChanged(user => {
  //   if (!user) {
  //     router.push({ path: "login" });
  //   }
  // });

  Object.defineProperties(Vue.prototype, {
    $db: {
      get() {
        return DB;
      }
    },
    $auth: {
      get() {
        return AUTH;
      }
    },
    $storage: {
      get() {
        return STORAGE;
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/plugins/firebase.js